<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-2.jpg)' }"></div>
              <img src="public/images/pages/services/banner-2.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <h5 class="title">Macetas de plastico Decorativas</h5>

            <p>
              Las macetas son un elemento imprescindible para dar alegría y vida a cualquier casa. En esta sección puedes encontrar de todo tipo, ofrecemos una selección completa de macetas decorativas, en cuanto a estilo y forma para cubrir cualquier necesidad. La linea de macetas decorativas PPI son fabricadas con Polipropileno de alto impacto que les confiere una gran resistencia a los golpes y son ligeras resistentes y durables.
            </p>

            <br />
            <p class="note">
              Maceta Decorativas<br />
              Manufactured by: Procesos Plasticos Inyectados S.A de C.V<br />
              Model: Maceta Decorativa<br />
              Product ID: Deco<br />
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
